/* eslint-disable max-len */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../services/data.services";
import { CognitoCurrentData } from "../../CommonMethods/CognitoData";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const InstitutionUsers = createAsyncThunk('institution-user-list', async (searchParams) => {
    const user = await CognitoCurrentData()
    let res = await dataService.GetAPI(`users?institution_id=${user['custom:institution_id']}&user_type=institution-user&${(searchParams.toString())} `);
    return res
})
const InstitutionUserSlice = createSlice({

    name: 'institution-user-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        },
        handleDataRoles: (state, action) => {
            state.roleList = action.payload
        }

    },
    extraReducers: {
        [InstitutionUsers.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [InstitutionUsers.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [InstitutionUsers.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading,handleDataRoles } = InstitutionUserSlice.actions;
export default InstitutionUserSlice.reducer